export const painPoints = [
  'No entendés qué significan esos términos médicos que escuchás una y otra vez.',
  'No sabés en qué información confiar y en cuál no.',
  'Las dudas se te acumulan y nunca se transforman en preguntas claras.',
  'Sentís que estás haciendo algo mal porque "no sabés lo suficiente".',
  'Confusión constante, sin una herramienta que te ayude a ordenarla.'
];

export const costs = [
  'Siguiendo confundida cada vez que recibís información',
  'Gastando energía en ordenar cosas que ya deberían estar claras',
  'Perdiendo oportunidades de comunicarte mejor con el médico',
  'Sobrecarga mental sin una herramienta que te ayude a ordenarla',
  'Dudas acumuladas que nunca se transforman en preguntas claras'
];

export const faqs = [
  ['¿Necesito ser médica o tener conocimientos especiales?', 'No. La guía está diseñada para madres sin formación médica. Solo necesitás querer entender mejor.'],
  ['¿Cuánto tiempo me toma completar la guía?', '14 días de trabajo práctico. Dedicale entre 20 y 30 minutos diarios. Los volúmenes se trabajan simultáneamente.'],
  ['¿La guía me enseña a interpretar estudios médicos?', 'No. Te ayuda a comprender términos y explicaciones generales, no a interpretar estudios médicos.'],
  ['¿Reemplaza el acompañamiento médico?', 'Absolutamente no. Es educativo e informativo. Complementa tu seguimiento; nunca lo reemplaza.'],
  ['¿Es completamente digital?', 'Sí. Acceso inmediato por email en PDF. Podés leerlo desde celular, tablet o computadora. También podés imprimirlo.'],
  ['¿La garantía de 14 días es real?', 'Completamente real. Si no te sirve, devolución del 100% sin preguntas.']
] as const;

export const stats = [
  ['+850', 'madres usando la guía'],
  ['3', 'Volúmenes completos'],
  ['5', 'Bonos incluidos'],
  ['4.8/5', 'calificación']
] as const;
